<!-- 收货明细-商品明细详情弹出框 -->
<template>
  <van-overlay :show="show" @click="onSendClose">
    <div class="content" v-if="info" @click.stop>
      <div class="tool">
        <label>商品明细</label>
        <i class="iconfont guanbi" @click="onSendClose"></i>
      </div>
      <div class="content-main">
        <section>
          <label>商品名称</label>
          <label>{{ info.productName }}</label>
        </section>
        <section>
          <label>国际编码</label>
          <label>{{ info.barCode }}</label>
        </section>
        <section>
          <label>效期</label>
          <label>{{ info.productDate | dateSub }} ~ {{ info.invalidDate | dateSub }}</label>
        </section>
        <section>
          <label>规格</label>
          <label>{{ info.specVal }}</label>
        </section>
        <section>
          <label>商品状态</label>
          <label v-for="status in ProductStatus()" :key="status.value">
            <span v-if="status.value === info.productStatus" :style="'color:' + status.color">
              {{ status.label }}
            </span>
          </label>
<!--          <label>-->
<!--            <span :style="info.defectFlag ? 'color: #F56C6C' : 'color: #67C23A'">-->
<!--              {{ info.defectFlag ? "不良品" : "良品" }}-->
<!--            </span>-->
<!--          </label>-->
        </section>
        <section>
          <label>数量</label>
          <label>{{ info.qty }}</label>
        </section>
        <section>
          <label>板号</label>
          <label>{{ info.bandSn }}</label>
        </section>
        <section>
          <label>批次</label>
          <label>{{ info.batSn }}</label>
        </section>
<!--        <section>-->
<!--          <label>项次</label>-->
<!--          <label>{{ info.itemSn }}</label>-->
<!--        </section>-->
      </div>
      <!-- <div class="sub-tool">
          <label style="background-color:#9AC0CD;">打印</label>
          <label @click="onDelGoodsDetail">删除</label>
      </div> -->
    </div>

  </van-overlay>
</template>

<script>
import {ProductStatus} from "../common/constant";

export default {
  data() {
    return {};
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    info: {
      type: Object,
      default: function () {
        return {
          goodsInfoResponseVO: {}
        };
      }
    }
  },
  methods: {
    ProductStatus() {
      return ProductStatus
    },
    // 发送关闭事件
    onSendClose() {
      this.$emit("closeDialog");
    },

    // // 发送修改明细事件
    // onEditGoodsDetail(){
    //     this.$emit("bindEditGoodsDetail");
    // }
  },
};
</script>

<style lang="scss" scoped>
.van-overlay {
  padding: 3rem 1rem 1rem 1rem;
}

.content {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  box-sizing: border-box;
  background-color: white;
  border-radius: 0.3rem;
  color: #444;

  .tool {
    display: flex;
    width: 100%;
    justify-content: space-between;
    height: 2.6rem;
    align-items: center;
    padding: 0 0.5rem;
    font-size: 0.9rem;
    border-bottom: 1px solid #eee;

    i {
      font-size: 0.9rem;
    }
  }
}

.content-main {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  padding: 0.5rem;

  section {
    display: flex;
    width: 100%;
    height: 2.5rem;
    align-items: center;
    font-size: 0.85rem;

    label:first-child {
      display: inline-flex;
      width: 5rem;
    }

    .van-cell {
      padding: 0;
      border: 1px solid #f0f0f0;
      border-radius: 0.2rem;
      width: 13rem;
      padding-left: 0.5rem;
      line-height: 2rem;
    }

    .van-radio-group {
      display: flex;
      width: 100%;
      padding-left: 0.5rem;
    }

    .van-radio {
      width: 6rem;
    }

    .date {
      border: 1px solid #f0f0f0;
      border-radius: 0.2rem;
      width: 13rem;
      padding-left: 0.5rem;
      box-sizing: border-box;
      line-height: 2rem;
    }
  }
}

.sub-tool {
  display: flex;
  width: 100%;
  height: 3rem;
  align-content: center;
  justify-content: flex-end;
  padding-right: 1rem;
  border-top: 1px solid #eee;
  align-items: center;

  label {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 4rem;
    height: 2rem;
    background-color: #dc6350;
    color: white;
    font-size: 0.9rem;
    border-radius: 0.3rem;
    margin-left: 1.5rem;
  }

}
</style>



// WEBPACK FOOTER //
// src/components/receivingGoodsDetailDialog.vue